import { string } from 'prop-types'

import Flag from 'views/components/atoms/Flag'

const ProductLabelCommon = ({ label }) => (
  <li className="u-vertical-align--top u-margin-small--bottom u-margin-small--right o-ProductLabels__ProductLabelContainer">
    <Flag label={label} />
  </li>
)

ProductLabelCommon.propTypes = {
  label: string.isRequired,
}

export default ProductLabelCommon
